import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, } from "react-router-dom";

import Header from './Components/Header/Header'
import Footer from "./Components/Pages/Footer";
import TopControl from "./Components/Pages/TopControl";
import PreLoader from "./Components/Pages/PreLoader";
const LazyHome = lazy(() => import('./Components/Home/Home'))
const LazyHomeTwo = lazy(() => import('./Components/Home/HomeTwo'))
const LazyPortfolioDetails = lazy(() => import('./Components/Pages/Portfolio/PortfolioDetails'))


function App() {
  return (

    <BrowserRouter >
      <Header />
      <Routes>
        <Route path="/" element={<Suspense fallback={<PreLoader />}><LazyHome /></Suspense>} />
        <Route path="/portfolio-details" element={<Suspense fallback={<PreLoader />}> <LazyPortfolioDetails /></Suspense>} />
        <Route path="/home-two" element={<Suspense fallback={<PreLoader />}> <LazyHomeTwo /></Suspense>} />
      </Routes>
      <Footer />
      <TopControl />

    </BrowserRouter>
  );
}

export default App;
